__turbopack_context__.v({
  "artworkGlow": "register-page-module__ghzeKG__artworkGlow",
  "errorMessage": "register-page-module__ghzeKG__errorMessage",
  "eyebrow": "register-page-module__ghzeKG__eyebrow",
  "field": "register-page-module__ghzeKG__field",
  "form": "register-page-module__ghzeKG__form",
  "formContent": "register-page-module__ghzeKG__formContent",
  "formHeader": "register-page-module__ghzeKG__formHeader",
  "formKicker": "register-page-module__ghzeKG__formKicker",
  "formNote": "register-page-module__ghzeKG__formNote",
  "formPanel": "register-page-module__ghzeKG__formPanel",
  "heroArtwork": "register-page-module__ghzeKG__heroArtwork",
  "heroCopy": "register-page-module__ghzeKG__heroCopy",
  "heroDescription": "register-page-module__ghzeKG__heroDescription",
  "heroPanel": "register-page-module__ghzeKG__heroPanel",
  "inputShell": "register-page-module__ghzeKG__inputShell",
  "labelRow": "register-page-module__ghzeKG__labelRow",
  "loaderTurn": "register-page-module__ghzeKG__loaderTurn",
  "page": "register-page-module__ghzeKG__page",
  "passportFloat": "register-page-module__ghzeKG__passportFloat",
  "passwordToggle": "register-page-module__ghzeKG__passwordToggle",
  "registrationShell": "register-page-module__ghzeKG__registrationShell",
  "requirement": "register-page-module__ghzeKG__requirement",
  "requirementMet": "register-page-module__ghzeKG__requirementMet",
  "shellIn": "register-page-module__ghzeKG__shellIn",
  "spinner": "register-page-module__ghzeKG__spinner",
  "stage": "register-page-module__ghzeKG__stage",
  "submitButton": "register-page-module__ghzeKG__submitButton",
  "turnstileWrap": "register-page-module__ghzeKG__turnstileWrap",
});
